<div
  class="border border-[#BAB8AE] rounded-[2rem] flex items-center justify-center w-full py-4 px-8 text-lg font-semibold cursor-pointer"
  [ngClass]="wrapperClass"
  (click)="auth.openWallet()"
>
  <wen-icon-wallet></wen-icon-wallet>
  <div class="ml-2.5" i18n>Connect wallet</div>
</div>
